module.exports = __webpack_public_path__ + "static/media/small-lite-alt_2x.529fca49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/small-lite-alt_2x.png
// module id = 646
// module chunks = 27